import { useT } from '@/i18n'

/** Analitika ekranlari uchun qo'lda "Yangilash" tugmasi (PageHeader `actions`да; qayta-fetch). */
export function RefreshButton({ onClick }: { onClick: () => void }) {
  const t = useT()
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
    >
      {t.table.refresh}
    </button>
  )
}
